import { Avatar } from "@mui/material";
import { FC } from "react";

// From https://mui.com/material-ui/react-avatar/#letter-avatars
const stringToColor = (string: string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

// From https://mui.com/material-ui/react-avatar/#letter-avatars
const stringAvatar = (firstName: string, lastName: string) => {
  return {
    sx: {
      bgcolor: stringToColor(`${firstName} ${lastName}`),
    },
    children: `${firstName[0] || ""}${lastName[0] || ""}`,
  };
};

interface AvatarInitialsProfileProps {
  firstName: string;
  lastName: string;
}

const AvatarInitialsProfile: FC<AvatarInitialsProfileProps> = ({
  firstName,
  lastName,
}) => <Avatar {...stringAvatar(firstName, lastName)} />;

export default AvatarInitialsProfile;
